import * as React from 'react'
import { TaskStatusWrapper } from '@/modules/shared/components'
import ViewMode from './ViewMode'
import { withRouter } from '@/app/navigation/withRouter'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const DriversViewControlBar = () => {
  const { t } = useLocalize()
  const { activeViewMode } = useDrivers()

  return (
    <TaskStatusWrapper>
      <div className="tw-relative tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-start tw-gap-2 tw-border-b tw-pr-4 md:tw-gap-4">
        <ViewMode padding />
        <div className="tw-py-2 tw-font-medium tw-text-content-base">
          {activeViewMode === 'group'
            ? t('common.view-mode-group')
            : t('common.view-mode-single')}
        </div>
      </div>
    </TaskStatusWrapper>
  )
}

export default withRouter(DriversViewControlBar)
